import { createRouter, createWebHistory } from "vue-router";
import Main from "@/pages/main";
import ltr from "@/pages/ltr";
import Index from "@/pages/index";
import Navbarblog from "@/components/navbarblog";

import Bloglist from "@/demo_pages/blog_list";
import Blogdetails from "@/demo_pages/blog_details";
import Blogsleftside from "@/demo_pages/blogs_leftside";
import Blogsrightside from "@/demo_pages/blogs_rightside";
import Blogleftsidebar from "@/demo_pages/blog_details_left_sidebar";
import Blogrightsidebar from "@/demo_pages/blog_details_right_sidebar";
import Pagenotfound from "@/other_pages/pagenotfound";

import Signup from "@/other_pages/signup";
import Signin from "@/other_pages/signin";
import Forgotpassword from "@/other_pages/forgot_password";
import Thankyou from "@/other_pages/thank_you";
import Review from "@/other_pages/review";
import FAQpage from "@/other_pages/FAQ_page";
import Comingsoon from "@/other_pages/coming_soon";
import Downloadpage from "@/other_pages/download";
import Request from "@/other_pages/request";

import Indexrtl from "@/rtl/pages/Indexrtl";
import rtl from "@/pages/rtl";
import Navbarrtl from "@/rtl/components/navbar";
import Navbarblogrtl from "@/rtl/components/navbarblog.vue";

const routes = [
  {
    path: "/",
    redirect: "/chatloop",
  },
  {
    path: "/chatloop",
    name: "Main_page",
    components: {
      default: Main,
    },
    meta: {
      title: 'Chatloop - Vue App Landing HTML Templates',
    }
  },
  {
    path: "/chatloop/404",
    name: "pagenotfound",
    component: Pagenotfound,
    meta: {
      title: '404 - ChatLoop | Vue App Landing HTML Templates',
    }
  },
  {
  
    path: "/:pathMatch(.*)*",
    redirect: "/chatloop/404",
  },
  {
    path: "/chatloop",
    components: {
      default: ltr,
    },
    children: [
      {
        path: "index",
        name: "Index",
        components: {
          default: Index,
          
        },
        meta: {
          title: 'Home Page - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "blog-list",
        name: "Bloglist",
        components: {
          default: Bloglist,
          navbar: Navbarblog,
        },
        meta: {
          title: 'Blog List - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "blog-details",
        name: "Blogdetails",
        components: {
          default: Blogdetails,
          navbar: Navbarblog,
        },
        meta: {
          title: 'Blog Details - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "blogs-leftside",
        name: "Blogsleftside",
        components: {
          default: Blogsleftside,
          navbar: Navbarblog,
        },
        meta: {
          title: 'Blog Left Sidebar - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "blogs-rightside",
        name: "Blogsrightside",
        components: {
          default: Blogsrightside,
          navbar: Navbarblog,
        },
        meta: {
          title: 'Blog Right Sidebar - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "blog-details-with-left-sidebar",
        name: "Blogleftsidebar",
        components: {
          default: Blogleftsidebar,
          navbar: Navbarblog,
        },
        meta: {
          title: 'Blog Left Sidebar Details - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "blog-details-with-right-sidebar",
        name: "Blogrightsidebar",
        components: {
          default: Blogrightsidebar,
          navbar: Navbarblog,
        },
        meta: {
          title: 'Blog Right Sidebar Details - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "sign-up",
        name: "Signup",
        component: Signup,
        meta: {
          title: 'Sign Up - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "sign-in",
        name: "Signin",
        component: Signin,
        meta: {
          title: 'Sign In - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "forgot-password",
        name: "Forgotpassword",
        component: Forgotpassword,
        meta: {
          title: 'Forgot Password - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "review",
        name: "Review",
        components: {
          default: Review,
          navbar: Navbarblog,
        },
        meta: {
          title: 'Review - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "thank-you",
        name: "Thankyou",
        component: Thankyou,
        meta: {
          title: 'Thank You - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "FAQ-page",
        name: "FAQpage",
        components: {
          default: FAQpage,
          navbar: Navbarblog,
        },
        meta: {
          title: 'Faq - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "download",
        name: "Downloadpage",
        component: Downloadpage,
        meta: {
          title: 'Download - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "coming-soon",
        name: "Comingsoon",
        component: Comingsoon,
        meta: {
          title: 'Comingsoon - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "request",
        name: "Request",
        components: {
          default: Request,
          navbar: Navbarblog,
        },
        meta: {
          title: 'Request - ChatLoop | Vue App Landing HTML Templates',
        }
      },
    ],
  },

  {
    path: "/chatloop/rtl",
    components: {
      default: rtl,
    },
    meta: { isRtl: true },
    children: [
      {
        path: "",
        name: "Indexrtl",
        components: {
          default: Indexrtl,
          navbar: Navbarrtl,
        },
        meta: {
          title: 'Home Page - ChatLoop | Vue App Landing HTML Templates',
          isRtl: true,
        }
      },
      {
        path: "blog-list",
        name: "Bloglistrtl",
        components: {
          default: Bloglist,
          navbar: Navbarblogrtl,
        },
        meta: {
          title: 'Blog List - ChatLoop | Vue App Landing HTML Templates',
          isRtl: true,
        }
      },
      {
        path: "blog-details",
        name: "Blogdetailsrtl",
        components: {
          default: Blogdetails,
          navbar: Navbarblogrtl,
        },
        meta: {
          title: 'Blog Details - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "blogs-leftside",
        name: "Blogsleftsidertl",
        components: {
          default: Blogsleftside,
          navbar: Navbarblogrtl,
        },
        meta: {
          title: 'Blog Left Sidebar - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "blogs-rightside",
        name: "Blogsrightsidertl",
        components: {
          default: Blogsrightside,
          navbar: Navbarblogrtl,
        },
        meta: {
          title: 'Blog Right Sidebar - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "blog-details-with-left-sidebar",
        name: "Blogleftsidebarrtl",
        components: {
          default: Blogleftsidebar,
          navbar: Navbarblogrtl,
        },
        meta: {
          title: 'Blog Left Sidebar Details - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "blog-details-with-right-sidebar",
        name: "Blogrightsidebarrtl",
        components: {
          default: Blogrightsidebar,
          navbar: Navbarblogrtl,
        },
        meta: {
          title: 'Blog Right Sidebar Details - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "sign-up",
        name: "Signuprtl",
        component: Signup,
        meta: {
          title: 'Sign Up - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "sign-in",
        name: "Signinrtl",
        component: Signin,
        meta: {
          title: 'Sign In - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "forgot-password",
        name: "Forgotpasswordrtl",
        component: Forgotpassword,
        meta: {
          title: 'Forgot Password - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "review",
        name: "Reviewrtl",
        components: {
          default: Review,
          navbar: Navbarblogrtl,
        },
        meta: {
          title: 'Review - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "thank-you",
        name: "Thankyourtl",
        component: Thankyou,
        meta: {
          title: 'Thank You - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "FAQ-page",
        name: "FAQpagertl",
        components: {
          default: FAQpage,
          navbar: Navbarblogrtl,
        },
        meta: {
          title: 'Faq - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "download",
        name: "Downloadpagertl",
        component: Downloadpage,
        meta: {
          title: 'Download - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "coming-soon",
        name: "Comingsoonrtl",
        component:Comingsoon,
        
        meta: {
          title: 'Comingsoon - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "request",
        name: "Requestrtl",
        components: {
          default: Request,
          navbar: Navbarblogrtl,
        },
        meta: {
          title: 'Request - ChatLoop | Vue App Landing HTML Templates',
        }
      },
      {
        path: "404",
        name: "Pagenotfoundrtl",
        component: Pagenotfound,
        meta: {
          title: '404 - ChatLoop | Vue App Landing HTML Templates',
        }
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory('/chatloop/'),
  routes,

});

router.beforeEach((to) => {
  if (typeof (to.meta.title) === 'string') {
    document.title = to.meta.title;
  } 
});

export default router;
